import styled from 'styled-components'

const WrapDropDownFilterTimes = styled.div`
    position: relative;
`;

export {
    WrapDropDownFilterTimes
}